import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

interface Periods {
    period_id: number;
    name: string;
    start_date: string;
    end_date: string;
    is_active: boolean;
}

export const usePeriods = () => {
    return useQuery<Periods[]>({
        queryKey: ["periods"],
        queryFn: async () => {
            const { data } = await axiosClient.get("/periods",{ withCredentials: true });
            return data;
        },
    });
};
